import React, { useRef, useState, useEffect } from 'react';
import NextLink from 'next/link';
import { EventEmitter } from 'events';
import { done, start, configure } from 'nprogress';
import { usePathname, useSearchParams, useRouter as useRouter$1 } from 'next/navigation';

var eventEmitter = /*#__PURE__*/new EventEmitter();
function comparePassedLinks(links, _ref) {
  var href = _ref.href,
    nickname = _ref.nickname;
  var passedLink = links.filter(function (link) {
    return link.href === href || link.href + '/' === href || nickname && link.nickname === nickname;
  });
  var existEqualLinks = false;
  for (var index = 0; index < passedLink.length; index++) {
    var actualLink = passedLink[index];
    var nextLink = passedLink[index + 1];
    if (nextLink) {
      if (actualLink.href === nextLink.href || actualLink.nickname === nextLink.nickname) {
        existEqualLinks = true;
        break;
      } else {
        if (actualLink.href[actualLink.href.length - 1] !== '/' && actualLink.href + '/' === nextLink.href) {
          existEqualLinks = true;
          break;
        }
        existEqualLinks = false;
      }
    } else {
      existEqualLinks = false;
    }
  }
  return existEqualLinks;
}
function existEvent(links, _ref2) {
  var href = _ref2.href,
    nickname = _ref2.nickname;
  var existEqualLinks = comparePassedLinks(links, {
    href: href,
    nickname: nickname
  });
  if (existEqualLinks === true || eventEmitter.listenerCount("route-" + nickname) > 1 || eventEmitter.listenerCount("route-" + href) > 1) {
    return true;
  }
  return false;
}
/**
 * @deprecated Instead use the new useRouter() hook
 */
function changeRoute(RouteName, params) {
  var eventCalled = eventEmitter.emit("route-" + RouteName, params);
  if (!eventCalled) {
    throw new Error("The route name '" + RouteName + "' is not registered in the local and global Container Link!");
  }
}
function listenEmittedEvent(RouteName, callbackFn) {
  eventEmitter.addListener("route-" + RouteName, function (params) {
    callbackFn(params);
  });
}
function onEventListener(_ref3, callbackFn) {
  var href = _ref3.href,
    nickname = _ref3.nickname;
  listenEmittedEvent(href, callbackFn);
  if (nickname) {
    listenEmittedEvent(nickname, callbackFn);
  }
}
function removeEventListener(_ref4) {
  var href = _ref4.href,
    nickname = _ref4.nickname;
  eventEmitter.removeAllListeners("route-" + href);
  if (nickname) {
    eventEmitter.removeAllListeners("route-" + nickname);
  }
}
var eventListener = {
  on: onEventListener,
  remove: removeEventListener
};
var eventsService = {
  existEvent: existEvent,
  eventListener: eventListener
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function validateRoute(route, regex, routeType) {
  if (route.includes('{}')) {
    throw new Error("Invalid route: Then '" + route + "' Route contains '{}', but no parameters were provided.");
  }
  var openParenthesesCount = (route.match(/\{/g) || []).length;
  var closeParenthesesCount = (route.match(/\}/g) || []).length;
  if (openParenthesesCount === closeParenthesesCount && regex.test(route)) {
    return true;
  } else {
    if (routeType === 'nickname') {
      throw new Error("invalid nickname: The '" + route + "' nickname contains invalid characters. Only uppercase end lowercase letters, numbers, and the following special characters are allowed: ( !, @, #, $, %, &, -, _, ?. ).");
    }
    throw new Error("Invalid route: The route '" + route + "' can only contain letters, numbers, hyphens (-), underscores (_), slashes (/), and braces ({}).");
  }
}
function isAValidHrefRoute(route) {
  if (route === '/') {
    return true;
  }
  if (route[0] !== '/') {
    throw new Error("Invalid route: The '" + route + "' route must begin with '/'");
  }
  var regex = /^\/(([a-zA-Z0-9-_]+|\{[a-zA-Z0-9-_,]+\})\/?)+$/;
  return validateRoute(route, regex, 'href');
}
function isAValidNicknameRoute(route) {
  var regex = /^[a-zA-Z0-9!@#$%&\-_?.]+$/;
  return validateRoute(route, regex, 'nickname');
}
function isValidStringForURL(str) {
  var pattern = /^[a-zA-Z0-9_-]+$/;
  return pattern.test(str);
}
function matchDynamicRoute(absoluteUrl, dynamicValues) {
  if (absoluteUrl === '/') {
    return true;
  }
  if (!dynamicValues && absoluteUrl.includes('{') && absoluteUrl.includes('}')) {
    throw new Error("Missing 'dynamicValues' parameter, but the " + absoluteUrl + " route contains dynamic keys.");
  }
  var absoluteRouteParts = absoluteUrl.split('/');
  var dynamicKeys = dynamicValues == null ? void 0 : dynamicValues.map(function (dynamicValue) {
    if (!isValidStringForURL(dynamicValue.value.toString())) {
      throw new Error("The dynamicValue (" + dynamicValue.value + ") of '" + dynamicValue.key + "' key contains invalid characters. Use only letters, numbers, underscores (_) and hyphens (-). Spaces and other characters are not allowed");
    }
    return "{" + dynamicValue.key + "}";
  });
  var routeDynamicKeys = absoluteRouteParts.filter(function (part) {
    return part.includes('{') && part.includes('}');
  });
  var dynamicKeysSet = new Set(dynamicKeys);
  if (!routeDynamicKeys.length && typeof dynamicValues === 'undefined') {
    return true;
  }
  if (routeDynamicKeys.length !== (dynamicValues == null ? void 0 : dynamicValues.length)) {
    throw new Error('The number of dynamic keys in the route does not match the number of dynamic values specified.');
  }
  for (var _iterator = _createForOfIteratorHelperLoose(routeDynamicKeys), _step; !(_step = _iterator()).done;) {
    var part = _step.value;
    if (!dynamicKeysSet.has(part)) {
      throw new Error("The dynamic route '" + part + "' passed was not found in dynamicValues. Please check which prams are available!");
    }
  }
  return true;
}
function replaceDynamicValues(absoluteUrl, dynamicValues) {
  var substitutedUrl = absoluteUrl;
  if (dynamicValues) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(dynamicValues), _step2; !(_step2 = _iterator2()).done;) {
      var dynamicValue = _step2.value;
      var key = "{" + dynamicValue.key + "}";
      var value = dynamicValue.value;
      substitutedUrl = substitutedUrl.replace(new RegExp(escapeRegExp(key), 'g'), value.toString());
    }
  }
  return substitutedUrl;
}
function escapeRegExp(key) {
  return key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function generateQueryString(queryStrings) {
  var query = '';
  queryStrings.forEach(function (param, index) {
    var qy = param.key + "=" + param.value;
    if (index === 0) {
      query = '?' + qy;
    } else {
      query += '&&' + qy;
    }
  });
  return query;
}
var routeService = {
  isAValidHrefRoute: isAValidHrefRoute,
  matchDynamicRoute: matchDynamicRoute,
  replaceDynamicValues: replaceDynamicValues,
  generateQueryString: generateQueryString,
  isAValidNicknameRoute: isAValidNicknameRoute
};

function Link(linkProps) {
  var linkRef = useRef(null);
  var _useState = useState(linkProps.href),
    link = _useState[0],
    setLink = _useState[1];
  useEffect(function () {
    eventsService.eventListener.on(linkProps, function (event) {
      var newLink = linkProps.href;
      if (routeService.matchDynamicRoute(linkProps.href, event == null ? void 0 : event.dynamicRoute)) {
        newLink = routeService.replaceDynamicValues(linkProps.href, event == null ? void 0 : event.dynamicRoute);
      }
      if (event != null && event.queryStrings && event.queryStrings.length > 0) {
        newLink += routeService.generateQueryString(event.queryStrings);
      }
      if (newLink !== link) {
        setLink(newLink);
      }
      if ((event == null ? void 0 : event.open) === 'newTab') {
        open(newLink, '_blank');
        return;
      }
      setTimeout(function () {
        var _linkRef$current;
        (_linkRef$current = linkRef.current) == null || _linkRef$current.click();
      }, 1);
    });
    return function () {
      eventsService.eventListener.remove(linkProps);
    };
  }, [linkProps]);
  return React.createElement(NextLink, {
    href: link,
    ref: linkRef,
    style: {
      display: 'none'
    }
  });
}

function ContainerLink(_ref) {
  var links = _ref.links;
  return React.createElement("div", null, links.map(function (link) {
    if (eventsService.existEvent(links, link)) {
      throw new Error("The href '" + link.href + "' or nickname '" + link.nickname + "' already exist in the local or global link list!");
    }
    routeService.isAValidHrefRoute(link.href);
    if (link.nickname) {
      routeService.isAValidNicknameRoute(link.nickname);
    }
    return React.createElement(Link, {
      href: link.href,
      nickname: link.nickname,
      key: link.href
    });
  }));
}

var progress = {
  done: function done$1() {
    var npgclass = document.querySelectorAll('html');
    done();
    [].forEach.call(npgclass, function (el) {
      el.classList.remove('nprogress-busy');
    });
  },
  start: function start$1() {
    start();
  }
};
function isAnchorOfCurrentUrl(currentUrl, newUrl) {
  var currentUrlObj = new URL(currentUrl);
  var newUrlObj = new URL(newUrl);
  // Compare hostname, pathname, and search parameters
  if (currentUrlObj.hostname === newUrlObj.hostname && currentUrlObj.pathname === newUrlObj.pathname && currentUrlObj.search === newUrlObj.search) {
    // Check if the new URL is just an anchor of the current URL page
    var currentHash = currentUrlObj.hash;
    var newHash = newUrlObj.hash;
    return currentHash !== newHash && currentUrlObj.href.replace(currentHash, '') === newUrlObj.href.replace(newHash, '');
  }
  return false;
}
function findClosestAnchor(element) {
  while (element && element.tagName.toLowerCase() !== 'a') {
    element = element.parentElement;
  }
  return element;
}
function isExternalLink(event, currentAnchor) {
  if (event.altKey || event.ctrlKey || event.shiftKey || currentAnchor.target === '_blank') return true;
  return false;
}
function handleClick(event) {
  try {
    var target = event.target;
    var anchor = findClosestAnchor(target);
    if (anchor) {
      if (isExternalLink(event, anchor)) return;
      var currentUrl = window.location.href;
      var newUrl = anchor.href;
      var isAnchor = isAnchorOfCurrentUrl(currentUrl, newUrl);
      if (newUrl === currentUrl || isAnchor) {
        progress.start();
        progress.done();
      } else {
        progress.start();
        (function (history) {
          var pushState = history.pushState;
          history.pushState = function () {
            progress.done();
            return pushState.apply(history, arguments);
          };
        })(window.history);
      }
    }
  } catch (err) {
    // Log the error in development only!
    console.log('NextTopLoader error: ', err);
    progress.start();
    done();
  }
}

var ProgressLoader = function ProgressLoader(_ref) {
  var propColor = _ref.color,
    propHeight = _ref.height,
    showSpinner = _ref.showSpinner,
    crawl = _ref.crawl,
    crawlSpeed = _ref.crawlSpeed,
    initialPosition = _ref.initialPosition,
    easing = _ref.easing,
    speed = _ref.speed,
    shadow = _ref.shadow,
    template = _ref.template,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1600 : _ref$zIndex;
  var pathname = usePathname();
  var searchParams = useSearchParams();
  var defaultColor = '#29d';
  var defaultHeight = 3;
  var color = propColor != null ? propColor : defaultColor;
  var height = propHeight != null ? propHeight : defaultHeight;
  // Any falsy (except undefined) will disable the shadow
  var boxShadow = !shadow && shadow !== undefined ? '' : shadow ? "box-shadow:" + shadow : "box-shadow:0 0 10px " + color + ",0 0 5px " + color;
  var styles = React.createElement("style", null, "#nprogress{pointer-events:none}#nprogress .bar{background:" + color + ";position:fixed;z-index:" + zIndex + ";top:0;left:0;width:100%;height:" + height + "px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;" + boxShadow + ";opacity:1;-webkit-transform:rotate(3deg) translate(0px,-4px);-ms-transform:rotate(3deg) translate(0px,-4px);transform:rotate(3deg) translate(0px,-4px)}#nprogress .spinner{display:block;position:fixed;z-index:" + zIndex + ";top:15px;right:15px}#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:2px solid transparent;border-top-color:" + color + ";border-left-color:" + color + ";border-radius:50%;-webkit-animation:nprogress-spinner 400ms linear infinite;animation:nprogress-spinner 400ms linear infinite}.nprogress-custom-parent{overflow:hidden;position:relative}.nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner{position:absolute}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg)}}@keyframes nprogress-spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
  useEffect(function () {
    configure({
      showSpinner: showSpinner != null ? showSpinner : true,
      trickle: crawl != null ? crawl : true,
      trickleSpeed: crawlSpeed != null ? crawlSpeed : 200,
      minimum: initialPosition != null ? initialPosition : 0.1,
      easing: easing != null ? easing : 'ease',
      speed: speed != null ? speed : 200,
      template: template != null ? template : "<div class=\"bar\" role=\"bar\">\n          <div class=\"peg\"></div>\n        </div>\n        <div class=\"spinner\" role=\"spinner\">\n          <div class=\"spinner-icon\"></div>\n        </div>"
    });
  }, []);
  useEffect(function () {
    // Add the global click event listener
    document.addEventListener('click', handleClick);
    // Clean up the global click event listener when the component is unmounted
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  useEffect(function () {
    progress.done();
  }, [pathname, searchParams]);
  return styles;
};

/**
 * The new and updated useRouter() hook
 */
function useRouter() {
  var router = useRouter$1();
  function push(routeName, params) {
    changeRoute(routeName, params);
  }
  function back() {
    progress.start();
    router.back();
  }
  function replace(routeName, params) {
    changeRoute(routeName, params);
  }
  return _extends({}, router, {
    push: push,
    back: back,
    replace: replace
  });
}

export { ContainerLink, ProgressLoader, changeRoute, useRouter };
//# sourceMappingURL=nextjs-progressloader.esm.js.map
